import BoardTreeContent from './BoardTreeContent';

export default BoardTreeContent;
